

import React, { useState, useContext } from 'react'; 
import UserContext  from '../../context/Globales/UserContext';
import PropTypes from 'prop-types'
import clsx from 'clsx';

import {v4 as uuid } from 'uuid';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableRow,
    makeStyles,
    TableHead,
    TableContainer,
    Modal, Fade, Backdrop, Button
  
} from '@material-ui/core';

import IcpdfDetalleBoletinLabModal from '../pdf/IC/IcpdfDetalleBoletinLabModal';



const useStyles = makeStyles((theme) => ({
    root: {},
    tituloTable: {
    
        backgroundColor: '#e6e6e6', 
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '16px',
        fontWeight: '250',
        fontSize : '16px'
     },  
    actions: {
      justifyContent: 'flex-end'
    }, 
    FondoTable :{
        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 290,
       
      },


      modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
      },

  }));
export const TblBoletinLaboModal = ({className, rest}) => {
    const { DatodetalleBoletinModal } = useContext(UserContext);
    const classes = useStyles();
    const [OpenModalpdfBoletin, setOpenModalpdfBoletin] = React.useState(false); 

    const handleClickOpenPdf = ()=>{

        setOpenModalpdfBoletin(!OpenModalpdfBoletin); 

    }



  
    return(
       
        <>


 {/*MODAL PDF INFORME COMER*/}

  <Modal
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    className={classes.modalPdf}
    open={OpenModalpdfBoletin}
    onClose={handleClickOpenPdf}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{
      timeout: 2000,
    }}>
    <Fade in={OpenModalpdfBoletin}>
    
      <div className={classes.paperPdf}>


        <IcpdfDetalleBoletinLabModal  />      

 
      
      </div>
 
    </Fade> 
    </Modal>




            <h6 className={classes.tituloTable}>Detalle sobre Boletin laboral</h6>

            <br />
            { DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen!=null ? <div style={{alignContent:"center", textAlign : "center"}}><Button variant="contained" color="primary" onClick={handleClickOpenPdf}>Descargar PDF</Button></div> : ''}

           <br />   

            { DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen==null ? <h2>Cargando información...</h2> :  ''}
              
            <TableContainer className={classes.containerTable}>

            <PerfectScrollbar>
                <Box align="center" >
                    <Table>
                        <TableHead className={classes.FondoTable}  >
                            <TableRow>
                               
                                <TableCell>Cant. de Infracciones</TableCell>
                                <TableCell>Cant. Deudas</TableCell>
                                <TableCell>Cant. Multas</TableCell>
                                <TableCell>N° Instituciones</TableCell>
                                <TableCell>Fecha Deuda más reciente</TableCell>
                                <TableCell>Fecha Multa más reciente</TableCell>
                               

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            
                                <TableRow
                               
                                key={uuid()}>
                                   
                                    <TableCell>{ DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroInfracciones}</TableCell>
                                    <TableCell>{ DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroDeudas}</TableCell>
                                    <TableCell>{ DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroMultas}</TableCell>
                                    <TableCell>{ DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroInstituciones}</TableCell>
                                    <TableCell>{ DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.FechaDeudaMasReciente}</TableCell>
                                    <TableCell>{ DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.FechaMultaMasReciente}</TableCell>
                                    

                                </TableRow>
                         
                        </TableBody>
                    </Table>
                </Box>

            </PerfectScrollbar>
            </TableContainer>

        {DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroDeudas !== 0 ? <h6 className={classes.tituloTable}>Detalles Deudas</h6> : ''}
           
        {DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroDeudas !== 0 ? (<TableContainer className={classes.containerTable}>

            <PerfectScrollbar>
                <Box align="center" >
                    <Table>
                        <TableHead className={classes.FondoTable}  >
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Institucion</TableCell>
                                <TableCell>Motivo</TableCell>
                                <TableCell>N° Boletín</TableCell>
                                <TableCell>F. Boletín</TableCell>
                                <TableCell>N° Página</TableCell>
                                <TableCell>Tipo de Infracción</TableCell>
                                <TableCell>F. Infracción</TableCell>
                                <TableCell>Monto</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { DatodetalleBoletinModal && DatodetalleBoletinModal.Deudas?.map((dDeudas, iddeuda)=>(
                                <TableRow
                               
                                key={uuid()}>
                                    <TableCell>{iddeuda+1}</TableCell>
                                    <TableCell>{dDeudas.Institucion}</TableCell>
                                    <TableCell>{dDeudas.Motivo}</TableCell>
                                    <TableCell>{dDeudas.NumeroBoletin}</TableCell>
                                    <TableCell>{dDeudas.FechaBoletin}</TableCell>
                                    <TableCell>{dDeudas.NumeroPagina}</TableCell>
                                    <TableCell>{dDeudas.TipoInfraccion}</TableCell>
                                    <TableCell>{dDeudas.FechaInfraccion}</TableCell>
                                    <TableCell style={{align: 'right'}}>$ {dDeudas.Monto}</TableCell>

                                  
                                    
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>

            </PerfectScrollbar>
            </TableContainer>
        ) :''}


            <br />
        { DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroMultas !== 0 ? <h6 className={classes.tituloTable}>Detalles Multas</h6> : '' }

            { DatodetalleBoletinModal && DatodetalleBoletinModal.Resumen?.NumeroMultas !== 0 ? (
           <TableContainer className={classes.containerTable}>

            <PerfectScrollbar>
                <Box >
                    <Table>
                        <TableHead className={classes.FondoTable}>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Institucion</TableCell>
                                <TableCell>Motivo</TableCell>
                                <TableCell>N° Boletín</TableCell>
                                <TableCell>F. Boletín</TableCell>
                                <TableCell>N° Página</TableCell>
                                <TableCell>Tipo de Infracción</TableCell>
                                <TableCell>F. Infracción</TableCell>
                                <TableCell >Monto</TableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { DatodetalleBoletinModal && DatodetalleBoletinModal.Multas?.map((dMultas, idmultas)=>(
                                <TableRow
                               
                                key={uuid()}>
                                    <TableCell>{idmultas+1}</TableCell>
                                    <TableCell>{dMultas.Institucion}</TableCell>
                                    <TableCell>{dMultas.Motivo}</TableCell>
                                    <TableCell>{dMultas.NumeroBoletin}</TableCell>
                                    <TableCell>{dMultas.FechaBoletin}</TableCell>
                                    <TableCell>{dMultas.NumeroPagina}</TableCell>
                                    <TableCell>{dMultas.TipoInfraccion}</TableCell>
                                    <TableCell>{dMultas.FechaInfraccion}</TableCell>
                                    <TableCell style={{align: 'right'}} >$ {dMultas.Monto}</TableCell>

                                  
                                    
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>

            </PerfectScrollbar>
            </TableContainer>
            ) : ''}

           
           
</>
    );
}
